import React from "react";
import styles from "./heroSection.module.css";

const HeroSection = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>Guiding Your Investment Journey</h1>
          <p className={styles.subtitle}>
            We exist to empower a select community of investors and institutions
            to grow their wealth and legacy through sustainable financial growth
            and enduring value.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
